
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 11.9a2 2 0 104 0 2 2 0 00-4 0zM16 11.9a4.974 4.974 0 00-1.028-3.037 1 1 0 011.587-1.217A6.974 6.974 0 0118 11.9c0 1.667-.584 3.2-1.557 4.402a1 1 0 01-1.554-1.258A4.975 4.975 0 0016 11.9zM8 11.9c0-1.145.384-2.198 1.03-3.04a1 1 0 10-1.586-1.218A6.974 6.974 0 006 11.9c0 1.665.583 3.197 1.554 4.399a1 1 0 001.556-1.258A4.975 4.975 0 018 11.901z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 11.9a8.96 8.96 0 00-2.156-5.845 1 1 0 111.52-1.3A10.96 10.96 0 0122 11.9c0 2.79-1.04 5.338-2.75 7.277a1 1 0 11-1.5-1.324A8.962 8.962 0 0020 11.9zM4 11.9a8.96 8.96 0 012.156-5.844 1 1 0 00-1.52-1.3A10.96 10.96 0 002 11.9c0 2.786 1.036 5.331 2.743 7.269a1 1 0 001.501-1.322A8.962 8.962 0 014 11.9z"}})])
          )
        }
      }
    